var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"view-index-page"},[_c('div',{staticClass:"app-index-box"},[_c('div',{staticClass:"app-index-view"},[_c('IndexLeft'),_vm._v(" "),_c('IndexCenter'),_vm._v(" "),_c('IndexRight')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730720dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/system-tunnel/Index.vue
// module id = null
// module chunks = 